import React from 'react';

import { Header, Navbar, NavPills } from '@C';
import ErrorBoundary from '@C/Error';
import { RouteSetup } from '@C/StaffManagement';

const routes = [
  {
    name: 'Staff Details',
    path: '/account/staff-management/manage',
  },
  {
    name: 'Attendance',
    path: '/account/staff-management/attendance',
  },
  {
    name: 'Advance Salary',
    path: '/account/staff-management/advancesalary',
  },
  {
    name: 'Advance Return',
    path: '/account/staff-management/advancereturn',
  },

  {
    name: 'Salary',
    path: '/account/staff-management/salary',
  },
];

const StaffManagement = () => {
  return (
    <main>
      <div className="page-wrapper">
        <Header title="Credit Customers" />
        <Navbar />
        <div className="page-content">
          <section className="page-components">
            <div className="page-title">
              <h1> Staff Management</h1>
            </div>

            <ErrorBoundary>
              <NavPills routes={routes} />
            </ErrorBoundary>
            <ErrorBoundary>
              <RouteSetup />
            </ErrorBoundary>
          </section>
        </div>
      </div>
    </main>
  );
};

export { StaffManagement };
